import pgwyClient from "@/api/pgwyClient";

// /api/statistics/certificates
// /api/statistics/expiring-certificates
// /api/statistics/issued-certificates
// /api/statistics/revoked-certificates

function toSimpleName(subjectDn) {
  return subjectDn.split(",").map(part => {
    let values = part.trim().split("=");
    return values.length > 1 ? values[1] : values[0];
  }).join(", ")
}

const Reports = {
  state: {
    CAs: [],
    issuedCertificates: {},
    revokedCertificates: {}
  },
  mutations: {
    setIssuedCertificates(state, issuedCertificates) {
      state.issuedCertificates = issuedCertificates.data.data;
      state.issuedCertificates.total = Object.values(issuedCertificates.data.data).reduce((a, b) => a + b, 0);
    },
    setRevokedCertificates(state, revokedCertificates) {
      state.revokedCertificates.total = revokedCertificates.data.data.reduce((a, b) => a + b, 0);
      state.revokedCertificates.certs = revokedCertificates.data.data;
    },
    setCas(state, value) {
      state.CAs = value;
    }
  },
  actions: {
    async updateCas({ commit, dispatch }, {issuedCertsParams, revokedCertsParams}) {
      const res = await pgwyClient.getIssuers();
      commit('setCas', [{ name: 'All CAs' }, ...res.data.issuers?.map(issuer =>
          ({
            subject: issuer.subjectDn,
            name: toSimpleName(issuer.subjectDn)
          }))]);
      await dispatch('updateIssuedCertificates', issuedCertsParams)
      await dispatch('updateRevokedCertificates', revokedCertsParams)
    },
    async updateIssuedCertificates({ commit }, issuedCertsParams) {
      const result = await pgwyClient.getStatistics("certificates", issuedCertsParams);
      commit('setIssuedCertificates', result);
    },
    async updateRevokedCertificates({ commit }, revokedCertsParams) {
      const result = await pgwyClient.getStatistics("revoked-certificates", revokedCertsParams);
      commit('setRevokedCertificates', result);
    },
  },
  getters: {
    getIssuedCertificates(state) {
      return state.issuedCertificates;
    },
    getRevokedCertificates(state) {
      return state.revokedCertificates;
    },
    getCAs(state) {
      return state.CAs;
    }
  },
};

export default Reports;
